import { useEffect, useState } from 'react';
import { useProperty } from '@eti/providers';
import { isFreeCancellationDaysAheadValid } from '../../utils/notification';

export const useFreeCancellationDaysAheadNotification = (departureDate) => {
  const { p } = useProperty();

  const [freeCancellationDaysAheadNotification, setFreeCancellationDaysAheadNotification] =
    useState(false);

  useEffect(() => {
    if (p('BookingFlow.FreeCancellationDaysAhead.Enabled')) {
      const freeCancellationDaysAhead = p('BookingFlow.FreeCancellationDaysAhead');
      const freeCancellationDaysAheadValidation = isFreeCancellationDaysAheadValid(
        departureDate,
        freeCancellationDaysAhead,
      );
      setFreeCancellationDaysAheadNotification(freeCancellationDaysAheadValidation);
    }
  }, [departureDate, p]);

  return freeCancellationDaysAheadNotification;
};
